import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

const QUERY = gql`
  query getKnowledgebases(
    $accountId: String!
    $title: String
    $category: String
    $page: Int!
    $size: Int!
  ) {
    knowledgebases(
      accountId: $accountId
      title: $title
      category: $category
      page: $page
      size: $size
    ) {
      content {
        id
        accountId
        title
        category
        body
        createdAt
        updatedAt
      }
      totalPages
      totalElements
      page
      size
    }
  }
`;

const useKnowledgebases = (
  accountId: string,
  title: string,
  category: string,
  page: number,
  size: number
) => {
  return useQuery(QUERY, {
    variables: {
      accountId: accountId,
      title: title,
      category: category,
      page: page,
      size: size,
    },
  });
};

export default useKnowledgebases;
